(function () {
  var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  var cutOffDeliveryHour = 11;
  var shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var holidayDates = ['12-25', '1-1'];
  var ReChargePortal = {
    cancelId: null,
    reactivateId: null,
    $cancelBtn: null,
    $reactivateBtn: null,
    $reactivateFinalBtn: null,
    $skipBtn: null,
    $unskipBtn: null,
    $changedatefriday: null,
    $finalBtn: null,
    $cancelTextarea: null,
    $reasonInputs: null,
    customerId: window.theme.customerId,
    cancelUrl: '/tools/softserve/api/customers/' + window.theme.customerId + '/subscriptions/cancel',
    reactivateUrl: '/tools/softserve/api/customers/' + window.theme.customerId + '/subscriptions/activate',
    cancelSubscriptionIds: [],
    chainedCall: function (data) {
      var $items = $(data.className);
      var params = data.params;
      var attribute = data.attribute;
      var uniqueParams = data.uniqueParams;
      var encrypted = data.encrypted;

      function _chained() {
        if ($items.length) {
          var request = [].shift.call($items),
            $element = $(request),
            url = typeof data.url != 'undefined' ? data.url : $element.find('a').attr(attribute);

          if (uniqueParams) {
            params = {};
            if (uniqueParams.date) {
              params.date = $element.find('a').data('date');
            }
            if (uniqueParams.charge_id) {
              params.charge_id = $element.find('a').data('charge');
            }
          }

          if (encrypted) {
            $.ajax(cryptUrl(url), {
              method: 'POST',
              dataType: 'json',
              data: JSON.stringify(params),
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.log(errorThrown, params);
                ModifyHealth.Sentry.captureException(errorThrown);
              },
            }).done(function () {
              _chained();
            });
          } else {
            $.ajax({
              url: url,
              type: 'post',
              dataType: 'json',
              data: typeof params !== 'undefined' ? params : {},
              error: function (jqXHR, textStatus, errorThrown) {
                console.log(errorThrown, params);
                ModifyHealth.Sentry.captureException(errorThrown);
              },
            }).done(function () {
              _chained();
            });
          }
        } else {
          location.reload();
        }
      }

      _chained();
    },
    cancelEventHandler: function () {
      var self = this;
      this.$cancelBtn.on('click', function () {
        self.cancelId = $(this).attr('id');
        var $modalReason = $('#subscription-cancel-modal-reason');
        var $modalInitial = $('#subscription-cancel-modal-initial');
        $modalReason.show();
        $modalInitial.hide();
        $('#subscription-cancel-modal .micromodal__footer:not(.micromodal__footer-cancel)').hide();
        $('#subscription-cancel-modal .micromodal__footer-cancel').show();
        MicroModal.show('subscription-cancel-modal');
        $('.' + self.cancelId).each(function (index, item) {
          self.cancelSubscriptionIds.push($(item).find('a').attr('data-item-id'));
        });
      });

      this.$finalBtn.on('click', function (e) {
        e.preventDefault();

        var cancellationReason = $('#subscription-cancel-comments').val().length
          ? 'Other: ' + self.$cancelTextarea.val()
          : $('#subscription-cancel-modal-reason input:checked').val();

        if (!cancellationReason) {
          return false;
        }

        let data = {
          className: '.' + self.cancelId,
          params: {
            cancellationReason: cancellationReason,
            subscriptionIds: self.cancelSubscriptionIds,
          },
          attribute: 'href',
          encrypted: true,
          url: self.cancelUrl,
        };

        self.$finalBtn.attr('disabled', true).addClass('loading');
        self.chainedCall(data);
      });

      this.$reasonInputs.on('change', function () {
        self.$cancelTextarea.val('');

        if (self.$reasonInputs.is(':checked')) {
          self.$finalBtn.attr('disabled', false);
        }
      });
    },
    reactivateEventHandler: function () {
      var self = this;

      this.$reactivateBtn.on('click', function () {
        self.reactivateId = $(this).attr('id');
        MicroModal.show('reactivate-subscription-modal');
      });

      this.$reactivateFinalBtn.on('click', function () {
        let data = {
          className: '.' + self.reactivateId,
          encrypted: false,
          attribute: 'data-url',
        };
        self.$reactivateFinalBtn.attr('disabled', true).addClass('loading');
        self.chainedCall(data);
      });
    },
    skipButtonHandler: function () {
      var self = this;
      this.$skipBtn.click(function () {
        $(this).parent().find('.skiploader').show();
        $(this).hide();
        var id = $(this).attr('id');

        let data = {
          className: '.' + id,
          attribute: 'data-url',
          encrypted: false,
          uniqueParams: {
            date: true,
            charge_id: true,
          },
        };

        self.chainedCall(data);

        return false;
      });
    },
    unskipButtonHandler: function () {
      var self = this;
      this.$unskipBtn.click(function () {
        $(this).parent().find('.skiploader').show();
        $(this).hide();
        var id = $(this).attr('id');

        let data = {
          className: '.' + id,
          attribute: 'data-url',
          encrypted: false,
          uniqueParams: {
            date: false,
            charge_id: true,
          },
        };

        self.chainedCall(data);
      });
    },
    adjustDate: function (dateObj) {
      var newDate = dateObj;
      var month = new Date(newDate).getMonth() + 1;
      var date = new Date(newDate).getDate();
      var day = new Date(newDate).getDay();
      var formattedDate = month + '-' + date;

      if (day === 5 && holidayDates.includes(formattedDate)) {
        newDate.setDate(newDate.getDate() - 1);
      }
      return newDate;
    },
    applyAdjustDate: function (date) {
      var newDate = date;

      var adjustmentValue = parseInt(typeof window.theme.dateAdjustment === 'undefined' ? 0 : window.theme.dateAdjustment);
      var dietType = document.getElementById('diet_type');
      if (dietType !== null && dietType.innerHTML === 'Mediterranean') {
        adjustmentValue = parseInt(
          typeof window.theme.dateAdjustmentMediterranean === 'undefined' ? 0 : window.theme.dateAdjustmentMediterranean
        );
      }

      if (adjustmentValue) {
        newDate.setDate(newDate.getDate() + adjustmentValue);
      }

      return newDate;
    },
    calculateDeliveryDate: function (scheduledAt, type) {
      if (typeof scheduledAt === 'undefined' || !scheduledAt.length) return false;
      var scheduledAtDate = new Date(scheduledAt);
      var getHours = scheduledAtDate.getHours();
      var getWeekDay = scheduledAtDate.getDay();

      //If it is Monday from 0AM till 5AM, then delivery will be this week Friday
      if (getHours >= 0 && getHours < cutOffDeliveryHour && getWeekDay === 1) {
        scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 4);
      } else {
        scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 11);
      }

      scheduledAtDate = this.adjustDate(scheduledAtDate);
      scheduledAtDate = this.applyAdjustDate(scheduledAtDate);

      var day = new Date(scheduledAtDate).getDay();
      var month = new Date(scheduledAtDate).getMonth();
      var date = new Date(scheduledAtDate).getDate();

      if (type === 'short') {
        return weekDays[day] + ', ' + shortMonthNames[month] + ' ' + date;
      }

      return weekDays[day] + ', ' + monthNames[month] + ' ' + date;
    },
    calculateScheduledDate: function (scheduledAt, processedAt, type) {
      if (typeof scheduledAt === 'undefined' || !scheduledAt.length) return false;
      var scheduledAtDate = new Date(processedAt ? processedAt : scheduledAt);
      var getHours = scheduledAtDate.getHours();
      var getWeekDay = scheduledAtDate.getDay();

      //If it is Monday from 0AM till 5AM, then delivery will be this week Friday
      if (getHours >= 0 && getHours < cutOffDeliveryHour && getWeekDay === 1) {
        scheduledAtDate.setDate(
          scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + (processedAt ? 11 : 4)
        );
      } else {
        scheduledAtDate.setDate(
          scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + (processedAt ? 18 : 11)
        );
      }

      scheduledAtDate = this.adjustDate(scheduledAtDate);
      scheduledAtDate = this.applyAdjustDate(scheduledAtDate);

      var day = new Date(scheduledAtDate).getDay();
      var month = new Date(scheduledAtDate).getMonth();
      var date = new Date(scheduledAtDate).getDate();

      if (type === 'short') {
        return weekDays[day] + ', ' + shortMonthNames[month] + ' ' + date;
      }
      return weekDays[day] + ', ' + monthNames[month] + ' ' + date;
    },
    updateNavActiveTitleHandler: function () {
      var $pageTitle = $('#page-title-ancor');
      var $navbarItems = $('#novum-navbar-menu li a');

      if (!$pageTitle.length) return false;

      $navbarItems.each(function (index, item) {
        var itemTitle = $(item).text();

        if (itemTitle === $pageTitle.text()) {
          $(item).addClass('active');
          return false;
        }
      });
    },
    init: function () {
      var self = this;
      this.$cancelBtn = $('.cancelbtn');
      this.$reactivateBtn = $('.reactivatebtn');
      this.$skipBtn = $('.skipbtn');
      this.$unskipBtn = $('.unskipbtn');
      this.$changedatefriday = $('.changedatefriday');
      this.$finalBtn = $('#cancel-subscription-btn-final');
      this.$reactivateFinalBtn = $('#reactivate-subscription-btn-final');
      this.$cancelTextarea = $('#subscription-cancel-comments');
      this.$reasonInputs = $('#subscription-cancel-modal-reason input');
      this.cancelEventHandler();
      this.reactivateEventHandler();
      this.skipButtonHandler();
      this.unskipButtonHandler();
      this.updateNavActiveTitleHandler();

      this.$cancelTextarea.on('input', function () {
        self.$reasonInputs.prop('checked', false);
        if (self.$cancelTextarea.val().length) {
          self.$finalBtn.attr('disabled', false);
        } else {
          self.$finalBtn.attr('disabled', true);
        }
      });

      this.$changedatefriday.each(function () {
        $(this).html(self.calculateDeliveryDate($(this).html()));
        $(this).show();
      });
    },
  };

  jQuery(document).ready(function () {
    ReChargePortal.init();
  });
})();
